import { Box, ButtonSize, Separator, Tag, Text } from '@bechtel/gds';
import { getSplittedToolCatalogName } from '@bechtel/ht-clients-common';
import { ToolInventory } from '@bechtel/ht-types';
import { useContext, useMemo } from 'react';
import { ErrorBoundary } from '~/components';
import { ActionContent } from '~/components/action-content';
import { ImageFallback } from '~/components/image-fallback';
import { SecondaryButtonStyled } from '~/styles';
import { ReturnToolContext } from '../../return-tool-context';
import { actionType } from '../../types';
import { DetailSectionStyled, ReturnItemStyled } from './styled';
import { ReturnListItemProps } from './type';

export const ReturnListItem: React.FC<ReturnListItemProps> = ({ toolOrder, hideCount }) => {
  const { selectedCheckInToolList, updateData } = useContext(ReturnToolContext);

  let isAddBtnDisabled: boolean = false;
  if (selectedCheckInToolList && selectedCheckInToolList?.length > 0) {
    isAddBtnDisabled =
      selectedCheckInToolList.findIndex((oldList: ToolInventory) => oldList.id === toolOrder.toolInventory?.id) != -1;
  }

  const detail = useMemo(
    () => getSplittedToolCatalogName(toolOrder.toolInventory?.description ?? ''),
    [toolOrder.toolInventory?.description]
  );

  const isSerialised = toolOrder && toolOrder.toolInventory?.isSerialized;
  return (
    <ErrorBoundary>
      <ReturnItemStyled>
        <Box px={{ sm: '500' }} pt={{ sm: '450' }} pb={{ sm: '550' }} justifyContent={{ sm: 'space-between' }}>
          <Box alignItems={{ sm: 'center' }}>
            <Box
              justifyContent={{ sm: 'center' }}
              alignItems={{ sm: 'center' }}
              my={{ sm: '200' }}
              ml={{ sm: '300' }}
              mr={{ sm: '500' }}
            >
              <ImageFallback
                src={toolOrder?.toolInventory?.toolCatalog?.toolCatalogImageUrl}
                fallbackName={toolOrder?.toolInventory?.toolCatalog?.toolCategory?.name}
              />
            </Box>
            <DetailSectionStyled flexDirection={{ sm: 'column' }} style={{ flex: '1' }}>
              <div>
                <Tag bgColor={isSerialised ? 'orange.200' : 'neutral.200'}>
                  <Text size="250" family={'openSansCondensed'}>
                    {toolOrder?.toolInventory?.barCode}
                  </Text>
                </Tag>
              </div>
              <Box mt={{ sm: '200' }} style={{ width: '160px' }}>
                <Text color="grey.900" weight="600" size="400" family={'openSans'} title={detail.title}>
                  {detail.title}
                </Text>
              </Box>
              {detail.subTitle && (
                <Box mt={{ sm: '200' }} px={{ sm: '200' }}>
                  <Text title={detail.subTitle} color="grey.600" weight="100" size="200" family={'openSans'}>
                    {detail.subTitle}
                  </Text>
                </Box>
              )}
            </DetailSectionStyled>
          </Box>
          {!hideCount && (
            <Box
              alignItems={{ sm: 'center' }}
              style={{ width: '30px' }}
              mr={{ sm: '300' }}
              justifyContent={{ sm: 'center' }}
            >
              <Text family="graphik">{toolOrder.dispatchQuantity > 0 ? toolOrder.dispatchQuantity : ''}</Text>
            </Box>
          )}
          <SecondaryButtonStyled
            onClick={() => {
              updateData && updateData(actionType.ADD, { checkInToolList: [toolOrder?.toolInventory] });
            }}
            style={{ marginTop: '12px' }}
            disabled={toolOrder.dispatchQuantity < 1 || isAddBtnDisabled}
            size={ButtonSize.SMALL}
          >
            <ActionContent icon="plus" label="Add" />
          </SecondaryButtonStyled>
        </Box>
        <Separator spacing="000" color="grey.300" />
      </ReturnItemStyled>
    </ErrorBoundary>
  );
};
